<template>
  <div class="modal-background">
    <div class="modal-header-new">
      <div class="logo">
        <img
          src="/img/apimetrics-context-logo-transparent.svg"
          alt="APImetrics by API Context"
          title="APImetrics by API Context"
          style="height: 57px"
        />
      </div>
      <div class="logout">
        <a v-if="!logoutInProgress" @click.prevent="logout" @keyup.enter="logout"> Logout </a>
        <LoadingAnim v-else />
      </div>
    </div>
    <div class="modal-overlay">
      <div class="center-container" :class="{ 'full-height': fullHeight && !logoutInProgress }">
        <div v-if="!logoutInProgress" class="progress-tracker">
          <ProgressTracker
            v-if="$route.meta.steps"
            :steps="$route.meta.steps"
            :current-step="currentStep"
          />
        </div>
        <div class="modal-content" :class="{ 'full-height': fullHeight }">
          <router-view
            v-if="!logoutInProgress"
            @update:current-step="handleCurrentStepUpdate"
          ></router-view
          ><!-- This has to be router-view instead of slot, not sure why but slot will not transfer the prop -->
          <h3 v-else>Logging out...</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressTracker from '../components/ProgressTracker.vue';

const DEFAULT_PROJECT_ID = 'defaultProjectId';

export default {
  name: 'ModalView',
  components: { ProgressTracker },
  props: {
    fullHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      steps: this.$route.meta.steps,
      currentStep: 0,
      isAllowedToContinue: false,
      logoutInProgress: false,
    };
  },
  methods: {
    handleCurrentStepUpdate(step) {
      this.currentStep = step;
    },
    async logout() {
      this.logoutInProgress = true;
      // window.sessionStorage.removeItem(APIM_TOKEN_KEY);
      window.sessionStorage.removeItem(DEFAULT_PROJECT_ID);
      try {
        await this.$fetcher.logout().catch((ex) => {
          console.warn(ex);
        });
      } catch (ex) {
        console.warn(ex);
      }
      await this.$auth.logout({ returnTo: process.env.VUE_APP_AUTH0_REDIRECT_URI });
    },
  },
};
</script>

<style scoped>
.modal-background {
  display: flex;
  flex-direction: column;
  background: radial-gradient(
    197.34% 216.57% at 124.73% -28.63%,
    #373e69 0%,
    #121421 24.33%,
    #121421 76.07%,
    #373e69 100%
  );
  height: 100vh;
  width: 100vw;
}
.modal-header-new {
  display: flex;
  justify-content: space-between;
  padding: 15px;
}
.logo {
  z-index: 1001;
}
.logout {
  padding-right: 10px;
  z-index: 1001;
}
.progress-tracker {
  display: flex;
  justify-content: center;
}
.center-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.center-container.full-height {
  height: 90%;
}

.modal-overlay {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  width: 100%;
  background: var(--dark-main);
  padding: 40px;
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: 0 2px 20px 2px rgba(255, 255, 255, 0.04);
  overflow-y: auto;
}

.modal-content.full-height {
  height: 100%;
}
@media (max-width: 600px) {
  .center-container {
    gap: 10px;
  }

  .modal-content {
    padding: 10px;
    border-radius: 4px;
  }

  .logo img {
    height: 40px;
  }
}
</style>
